import { Logger, LogManager } from "../logger/logger";

export interface Property
{
    getBaseURLSecuirty():string;
    getBaseURL():string;
    getStreamingURL(): string;
    getAboutURL(): string;
    getSessionTimeout(): number;
    getEncryptionKey(): string;
    getTuneFileType(): string;
    getRefreshTokenDelta(): number;
    getFaceBookURL(): string;
    getTwitterURL(): string;
    getToneShareURL(): string;
    getPublicKey(): string;
    getLinkedinLink(): string;
    getFaceBookLink(): string;
    getInstagramLink(): string;
    getResendOtpTimeout(): string;
    getChannelId():string;
    setChannelId(channelId: string): void;
}

export class PropertyImpl implements Property 
{
    private logger: Logger = LogManager.getLogger(PropertyImpl.name);
    private properties: any;
    private channelId: string = "1";

    constructor()
    {
        this.logger.log("PropertyImpl() invoked");
    }

    setProperty(properties: any)
    {
        this.properties = properties;

        this.channelId = this.properties["CHANNEL_ID"];
    }

    getBaseURLSecuirty(): string {
        return this.properties["BASE_URL_SECURITY"];
    }

    getChannelId(): string {
        return this.channelId;
    }
    setChannelId(channelId: string): void {
        this.channelId = channelId;
    }
     
    getSessionTimeout(): number {
        return +this.properties["SESSION_TIMEOUT"];
    }

    getBaseURL(): string {
        return this.properties["BASE_URL"];
    }

    getAboutURL(): string {
        return this.properties["ABOUT_URL"];
    }

    getStreamingURL(): string {
        return this.properties["STREAMING_URL"];
    }

    getRefreshTokenDelta(): number {
        return this.properties["REFRESH_TOKEN_DELTA"];
    }
  
    getFaceBookURL(): string {
        return this.properties["FACEBOOK_SHAREURL"];
    }

    getResendOtpTimeout(): string {
        return this.properties["RESEND_OTP_TIMEOUT"];
    }

    getTwitterURL(): string 
    {
        return this.properties["TWITTER_SHAREURL"];
    }

    getLinkedinLink(): string {
        return this.properties["LINKEDIN_LINK"];
    }

    getFaceBookLink(): string {
        return this.properties["FACEBOOK_LINK"];
    }

    getPublicKey(): string {
        return this.properties["PUBLIC_KEY"];
    }

    getInstagramLink(): string 
    {
        return this.properties["INSTAGRAM_LINK"];
    }

    getTuneFileType(): string {
        return this.properties["TUNE_FILE_TYPE"];
    }

    getToneShareURL(): string 
    {
        return this.properties["TONE_SHAREURL"];
    }

    getEncryptionKey(): string {
        return this.properties["ENCRYPTION_KEY"];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/property/property.ts